import Acceuil from "./advanced/Acceuil";


const Home = () => {
    return (
        <div>
          <Acceuil/>
         
        </div>
     )
}
 
export default Home;